import { PlayerEvent, type PlayerInterface } from '@foundation-player/loader';
import { readonly, writable, type Readable, type Writable } from 'svelte/store';
import type { SessionState } from '../types/player-state';
import type { PlayerStoreModule } from './player-store-types';

/**
 * Readable store for the session state.
 */
export class SessionStatePlayerStore implements PlayerStoreModule<'sessionState'> {
  readonly #sessionState: Writable<SessionState> = writable('not-yet-created');
  readonly sessionState: Readable<SessionState> = readonly(this.#sessionState);

  constructor(createPlayerOnDemand: boolean) {
    if (!createPlayerOnDemand) {
      this.#sessionState.set('loading');
    }
  }

  initializeStateFromPlayer(player: PlayerInterface) {
    this.#sessionState.set('loading');

    player.addEventListener(PlayerEvent.SessionStart, () => {
      this.#sessionState.set('loading');
    });

    player.addEventListener(PlayerEvent.Ready, () => {
      this.#sessionState.set('ready');
    });

    player.addEventListener(PlayerEvent.MediaStarted, () => {
      this.#sessionState.set('active');
    });

    player.addEventListener(PlayerEvent.SessionEnd, () => {
      this.#sessionState.set('ended');
    });

    // When resuming to play after the session ended, we manually mark the
    // session as active.
    // Technically, this works fine for a while - with some caveats:
    // - No events are pushed to NPAW
    // - When reaching the end of the medium, no further SessionEnd is dispatched
    player.addEventListener(PlayerEvent.Seeked, () => {
      this.#sessionState.set('active');
    });

    player.addEventListener(PlayerEvent.Playing, () => {
      this.#sessionState.set('active');
    });

    // It's not clear whether we need this state.
    // player.addEventListener(PlayerEvent.Error, () => {
    //   this.#sessionState.set('error');
    // });
  }
}
